import { Box, Button, Stack, Typography } from '@mui/material';
import GameSettings from '../../Settings/GameSettings';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../contexts/LanguageContext';

const gameSettings = new GameSettings();

const Credits = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleNavigate = () => {
        window.open('https://louve.systems/portal.php', '_blank', 'noopener,noreferrer');
    };

    const handleOtherGames = () => {
        window.open('https://jihana.fr', '_blank', 'noopener,noreferrer');
    };

    return (
        <>
            {/* Bottom-right */}
            <Button
                variant="outlined"
                onClick={() => navigate('/')}
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                    zIndex: 10,
                    color: '#c191ff',
                    borderColor: 'rgba(193, 145, 255, 0.4)',
                    textTransform: 'none',
                    fontSize: '0.85rem',
                    cursor: `${gameSettings.getRandomCursor()}, auto`,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        borderColor: '#c191ff',
                        backgroundColor: 'rgba(193, 145, 255, 0.1)',
                    },
                }}
            >
                {t('menu')}
            </Button>

            <Box
                display="flex"
                sx={{
                    backgroundColor: '#101728',
                    height: '100vh',
                    width: '100vw',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    cursor: `${gameSettings.getRandomCursor()}, auto`
                }}
            >
                <Stack
                    spacing={6}
                    sx={{
                        alignItems: 'center',
                        textAlign: 'center',
                        maxWidth: '500px',
                        px: 3,
                    }}
                >
                    {/* Coded by */}
                    <Stack spacing={1} alignItems="center">
                        <Typography
                            sx={{
                                color: '#c191ff',
                                fontSize: '1.1rem',
                                letterSpacing: '0.15em',
                                textTransform: 'uppercase',
                                textShadow: '0 0 12px rgba(193, 145, 255, 0.3)',
                            }}
                        >
                            {t('codedBy')}
                        </Typography>
                        <Typography
                            sx={{
                                color: 'white',
                                fontSize: '3rem',
                                fontWeight: 300,
                                letterSpacing: '0.08em',
                                textShadow: '0 0 20px rgba(193, 145, 255, 0.4)',
                            }}
                        >
                            Jihana
                        </Typography>
                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            onClick={handleOtherGames}
                            sx={{
                                cursor: 'pointer',
                                px: 2.5,
                                py: 1,
                                borderRadius: '20px',
                                border: '1px solid rgba(193, 145, 255, 0.3)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: 'rgba(193, 145, 255, 0.1)',
                                    border: '1px solid rgba(193, 145, 255, 0.6)',
                                    transform: 'scale(1.05)',
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: '20px',
                                    height: '20px',
                                    backgroundImage: 'url(/images/cursors/light_pink.png)',
                                    backgroundSize: 'contain',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                }}
                            />
                            <Typography
                                sx={{
                                    color: '#c191ff',
                                    fontSize: '1rem',
                                    letterSpacing: '0.05em',
                                }}
                            >
                                {t('otherGames')}
                            </Typography>
                        </Stack>
                    </Stack>

                    {/* Divider */}
                    <Box
                        sx={{
                            width: '80px',
                            height: '2px',
                            background: 'linear-gradient(90deg, transparent, #c191ff, transparent)',
                        }}
                    />

                    {/* Remerciements */}
                    <Stack spacing={3} alignItems="center">
                        <Typography
                            sx={{
                                color: '#c191ff',
                                fontSize: '0.85rem',
                                letterSpacing: '0.15em',
                                textTransform: 'uppercase',
                                textShadow: '0 0 12px rgba(193, 145, 255, 0.3)',
                            }}
                        >
                            {t('thanks')}
                        </Typography>

                        <Typography sx={{ color: 'white', fontSize: '1.1rem', textShadow: '0 0 10px rgba(193, 145, 255, 0.25)' }}>
                            Nicolas
                        </Typography>

                        <Stack spacing={0.5} alignItems="center">
                            <Typography sx={{ color: 'white', fontSize: '1.1rem', textShadow: '0 0 10px rgba(193, 145, 255, 0.25)' }}>
                                Louve Hurlante
                            </Typography>
                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                onClick={handleNavigate}
                                sx={{
                                    cursor: 'pointer',
                                    px: 2,
                                    py: 0.8,
                                    borderRadius: '20px',
                                    border: '1px solid rgba(193, 145, 255, 0.3)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: 'rgba(193, 145, 255, 0.1)',
                                        border: '1px solid rgba(193, 145, 255, 0.6)',
                                        transform: 'scale(1.05)',
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: '18px',
                                        height: '18px',
                                        backgroundImage: 'url(/images/cursors/single_purple.png)',
                                        backgroundSize: 'contain',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                    }}
                                />
                                <Typography
                                    sx={{
                                        color: '#c191ff',
                                        fontSize: '0.8rem',
                                        letterSpacing: '0.05em',
                                    }}
                                >
                                    {t('seeGames')}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>

                <Typography
                    sx={{
                        position: 'absolute',
                        bottom: 16,
                        left: 16,
                        color: 'rgba(255, 255, 255, 0.4)',
                        fontSize: '0.65rem',
                        maxWidth: '400px',
                        lineHeight: 1.4,
                    }}
                >
                    {t('disclaimer')}
                    <br />
                    {t('copyright')}
                </Typography>
            </Box>
        </>
    );
};

export default Credits;
